export default "__VITE_ASSET__i2ywl_YzKp2MjtOEr7ngzA__ 480w, __VITE_ASSET__tgItkVM6JTrfm2CiQnzY5g__ 768w, __VITE_ASSET__6bp_5It$EfTQ8f$omStdjw__ 1200w";